import { useNavigate } from 'react-router-dom';
import ResearchCompanyDialog from '../components/ResearchCompanyDialog';

/**
 * Full-page wrapper for the "Research New Company" flow.
 *
 * Renders ResearchCompanyDialog in page mode (no modal overlay,
 * full-width layout, back-navigation button instead of X close).
 *
 * Route: /companies/research
 */
export default function ResearchCompanyPage() {
  const navigate = useNavigate();
  return (
    <ResearchCompanyDialog
      isOpen={true}
      isPage={true}
      onClose={() => navigate('/companies')}
      onResearchComplete={() => { /* navigation to company happens inside the dialog */ }}
    />
  );
}
